import React, { FC, useState } from 'react';
import { ICalendarEventsProps } from './types';
import {Button, Modal, ModalBody, ModalHeader} from 'reactstrap';
import CalendarEvents from './index';
import FormButton from '../../generic/buttons/main';
import { t } from 'i18next';

const CalendarButton: FC<ICalendarEventsProps> = (props) => {
  const { className, ...rest } = props;
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button color={'primary'} type={'button'} onClick={() => setVisible(!visible)}
                disabled={false} className={className ? className : 'form-button'} {...rest}>{t('final.inCalendar')}</Button>
      <Modal
        isOpen={visible}
        className={'edit-modal'}
        toggle={() => setVisible(!visible)}
        centered
      >
        <ModalHeader>
          {t('final.inWhatCalendar')}
        </ModalHeader>
        <ModalBody>
          <CalendarEvents {...props} />
        </ModalBody>
      </Modal>
    </>
  )
}

export default CalendarButton;